module.exports = __webpack_public_path__ + "static/name-1a2850e652e5f66edf7a13bc1172e67e.svg";